import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import lazyLoadPlugin from './lazyLoad/plugin';
import episode from './modules/episode';
import register from './modules/register';
import show from './modules/show';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    plugins: [lazyLoadPlugin],
    modules: {
        episode,
        register,
        show,
    },
});
